class ProductPrice extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.compare_price = this.querySelector(".product-price--compare")),
      (this.price = this.querySelector(".product-price--original")),
      (this.reference_unit = this.querySelector(
        ".product-price--reference-unit"
      )),
      (this.reference_value = this.querySelector(
        ".product-price--reference-value"
      )),
      (this.root = this.closest(`[data-product-id='${this.dataset.id}']`)),
      (this.section_id = this.root.dataset.sectionId),
      (this.unit_price = this.querySelector(".product-price--unit-price")),
      (this.unit_price_container = this.querySelector(
        ".product-price--unit-container"
      )),
      this.updatePriceListener();
  }
  disconnectedCallback() {
    window.off("theme:product:variantChanged.productPrice-" + this.section_id);
  }
  updatePriceListener() {
    window.on(
      "theme:product:variantChanged.productPrice-" + this.section_id,
      ({ detail: { section: e, variant: t } }) => {
        e === this.root && this.updatePrices(t);
      }
    );
  }
  updatePrices(e) {
    e
      ? (this.removeAttribute("style"),
        (this.price.innerHTML = theme.utils.formatMoney(e.price)),
        e.compare_at_price > e.price
          ? ((this.compare_price.innerHTML = theme.utils.formatMoney(
              e.compare_at_price
            )),
            (this.compare_price.style.display = "inline-block"))
          : (this.compare_price.style.display = "none"),
        e.unit_price_measurement
          ? ((this.unit_price.innerHTML = theme.utils.formatMoney(
              e.unit_price
            )),
            (this.reference_unit.innerHTML =
              e.unit_price_measurement.reference_unit),
            1 === e.unit_price_measurement.reference_value &&
            this.reference_value
              ? (this.reference_value.style.display = "none")
              : this.reference_value &&
                ((this.reference_value.innerHTML =
                  e.unit_price_measurement.reference_value),
                (this.reference_value.style.display = "block")),
            (this.unit_price_container.style.display = "flex"))
          : (this.unit_price_container.style.display = "none"))
      : (this.style.display = "none");
  }
}
const productPriceEl = customElements.get("product-price-root");
productPriceEl || customElements.define("product-price-root", ProductPrice);
